exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flow-popover[data-v-bcbbf968]{position:relative;border:1px solid #ccc;margin-bottom:10px}.flow-popover .infoModalButton[data-v-bcbbf968]{position:absolute;top:10px;right:10px}", ""]);

// exports
